import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class MediaConfirmRemoveFileModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onRemove: PropTypes.func,
    item: PropTypes.object
  };

  onClose = () => {
    this.props.onClose();
  };

  onRemove = () => {
    this.props.onRemove();
  };

  render() {
    const { isOpen, item } = this.props;

    return (
      <Modal
        show={isOpen}
        dialogClassName='confirmation-remove-file-modal'
        backdrop='static'
        container={this}
        id='confirmation-remove-file'
      >
        <Modal.Body>
          <p>
            Delete <span style={{ fontWeight: 600 }}>{item.fileName}</span>?
          </p>

          <div className='confirm-remove-file-group-btn'>
            <button
              className='btn btn-primary btn-siteone-default'
              onClick={this.onClose}
            >
              Cancel
            </button>
            <button
              className='btn btn-siteone btn-siteone-danger'
              onClick={this.onRemove}
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default MediaConfirmRemoveFileModal;



// WEBPACK FOOTER //
// ./src/MediaLibrary/Components/media-confirm-remove-file-modal.js